
export const common = {
  // Navigation
  'nav.home': 'Главная',
  'nav.treatments': 'Лечение',
  'nav.howItWorks': 'Как это работает',
  'nav.supervision': 'Наблюдение',
  'nav.about': 'О нас',
  'nav.bookNow': 'Записаться',
  'nav.language': 'Язык',

  // Hero
  'hero.badge': 'Настоящие врачи. Настоящая забота. Настоящее спокойствие.',
  'hero.title.line1': 'Вы заслуживаете улыбки,',
  'hero.title.line2': 'Которой можно гордиться',
  'hero.subtitle1': 'Будь то боль, которую вы игнорировали, улыбка, которую вы скрывали, или расходы, из-за которых вы ждали — вам больше не нужно ждать.',
  'hero.subtitle2': 'Мы делаем стоматологическую помощь мирового класса в Турции безопасной, поддерживаемой и полностью доступной — с врачом, наблюдающим за каждым шагом.',
  'hero.cta.primary': 'Начать мой путь',
  'hero.cta.secondary': 'Сначала поговорить с кем-то',
  'hero.feature1': 'Под наблюдением врача от начала до конца',
  'hero.feature2': 'Уход, подходящий вашей жизни и бюджету',
  'hero.feature3': 'Поддержка на каждом шагу, рядом или вдали',

  // Services
  'services.badge': 'Ваш путь начинается здесь',
  'services.title': 'Процедуры, которые меняют ваше самочувствие каждый день',
  'services.subtitle': 'Готовы ли вы улыбаться без колебаний, есть без беспокойства или просто снова чувствовать себя собой — мы здесь, чтобы помочь',
  'services.cta': 'Изучить все процедуры',
  'services.swipeHint': 'Проведите, чтобы увидеть больше процедур',
  'services.learnMore': 'Узнать больше',
  'services.startingFrom': 'От',
  'services.perTooth': 'за зуб',

  'service.implants.title': 'Зубные импланты',
  'service.implants.desc': 'Ешьте, смейтесь и говорите с полной уверенностью. Почувствуйте себя собой с зубами, которые выглядят, ощущаются и функционируют как настоящие.',
  'service.veneers.title': 'Фарфоровые виниры',
  'service.veneers.desc': 'Перестаньте прятать улыбку на фотографиях. Просыпайтесь каждый день, любя то, что видите в зеркале, с улыбкой, которая наконец-то ваша.',

  'service.smile.title': 'Преображение улыбки',
  'service.smile.desc': 'Измените то, как вы себя чувствуете. Полное преображение улыбки, разработанное с учётом вашего лица, вашей жизни и уверенности, которой вы заслуживаете.',

  'service.orthodontics.title': 'Ортодонтия',
  'service.orthodontics.desc': 'Выровняйте зубы без смущения. Дискретное лечение, которое вписывается в ваш образ жизни и даёт вам улыбку, о которой вы всегда мечтали.',

  'service.whitening.title': 'Отбеливание зубов',
  'service.whitening.desc': 'Чувствуйте уверенность в каждом разговоре. Более яркая и белая улыбка, которая заставляет вас хорошо себя чувствовать каждый раз, когда вы говорите.',

  'service.root.title': 'Лечение корневых каналов',
  'service.root.desc': 'Перестаньте жить с зубной болью. Сохраните свой натуральный зуб и вернитесь к жизни без постоянного дискомфорта и беспокойства.',

  'service.crowns.title': 'Зубные коронки',
  'service.crowns.desc': 'Защитите и восстановите повреждённые зубы, чтобы снова есть то, что любите. Прочные коронки с естественным видом, которые служат годами.',

  'service.allon4.title': 'Импланты All-on-4',
  'service.allon4.desc': 'Верните свою жизнь всего за один день. Полный комплект постоянных зубов, позволяющий есть, улыбаться и жить без ограничений.',

  // How It Works
  'how.badge': 'Простой процесс',
  'how.title': 'Как это работает',
  'how.subtitle': 'Четыре простых шага для получения стоматологической помощи мирового класса с полной прозрачностью',
  'how.cta': 'Начать свой путь',

  'how.step1.number': '01',
  'how.step1.title': 'Запишитесь на лечение',
  'how.step1.desc': 'Выберите стоматологическую процедуру и загрузите рентгеновские снимки или сканы. Наша команда изучит их и составит персональный план лечения.',

  'how.step2.number': '02',
  'how.step2.title': 'Выберите наблюдение',
  'how.step2.desc': 'Выберите предпочтительный вариант наблюдения: независимый сторонний врач, ваш собственный стоматолог (получает 10%) или наш штатный эксперт.',

  'how.step3.number': '03',
  'how.step3.title': 'Получите лечение прозрачно',
  'how.step3.desc': 'Получите лечение в нашей клинике, аккредитованной JCI. Ваш наблюдатель проверяет все снимки, сканы и ход лечения в режиме реального времени.',

  'how.step4.number': '04',
  'how.step4.title': 'Последующий уход',
  'how.step4.desc': 'Продолжайте уход у своего стоматолога, который полностью осведомлён о вашем лечении. Мы предоставляем все записи и постоянную поддержку.',

  // Supervision
  'supervision.badge': 'Вы защищены на каждом шагу',
  'supervision.title': 'Беспокоитесь о лечении за рубежом?',
  'supervision.subtitle': 'Это беспокойство совершенно обоснованно — и именно поэтому мы создали эту систему. Каждый пациент получает специального наблюдателя, который следит за лечением с первого до последнего дня.',
  'supervision.swipeHint': 'Проведите, чтобы изучить варианты',
  'supervision.chooseOption': 'Выберите этот вариант при записи',

  'supervision.option1.title': 'Независимый сторонний врач',
  'supervision.option1.badge': 'Наиболее надёжный',
  'supervision.option1.desc': 'Кто-то на вашей стороне, кто отвечает только перед вами — не перед клиникой. Они проверяют каждый скан, одобряют каждый шаг и следят, чтобы ничего не было упущено.',
  'supervision.option1.feature1': 'Проверяет ваши снимки до начала любых процедур',
  'supervision.option1.feature2': 'Независимо одобряет ваш план лечения',
  'supervision.option1.feature3': 'Контролирует каждый этап вашего лечения',
  'supervision.option1.feature4': 'Подтверждает, что конечный результат соответствует стандарту',
  'supervision.option1.feature5': 'Нулевой конфликт интересов — они работают для вас',
  'supervision.option1.pricing': 'Что вы получаете: Полный независимый контроль',

  'supervision.option2.title': 'Ваш собственный стоматолог',
  'supervision.option2.badge': 'Наиболее комфортный',
  'supervision.option2.desc': 'Стоматолог, которому вы уже доверяете, остаётся частью вашего пути. Он знает вашу историю, знает вас — и остаётся в курсе на каждом шагу.',
  'supervision.option2.feature1': 'Ваш стоматолог получает все записи и сканы',
  'supervision.option2.feature2': 'В курсе на каждом этапе лечения',
  'supervision.option2.feature3': 'Проводит последующий уход дома',
  'supervision.option2.feature4': 'Получает 10% от стоимости лечения за своё время',
  'supervision.option2.feature5': 'Полная преемственность — никакого начала с нуля',
  'supervision.option2.pricing': 'Что вы получаете: Привычный уход, без пробелов',

  'supervision.option3.title': 'Наш штатный эксперт',
  'supervision.option3.badge': 'Включено',
  'supervision.option3.desc': 'Старший специалист с опытом более 15 лет наблюдает за вашим лечением на месте. Вы никогда не просто пациент — вы приоритет.',
  'supervision.option3.feature1': 'Более 15 лет специализированного опыта',
  'supervision.option3.feature2': 'Присутствует в клинике на протяжении всего лечения',
  'supervision.option3.feature3': 'Немедленно реагирует, если что-то не так',
  'supervision.option3.feature4': 'Поддерживает каждый шаг на высшем уровне',
  'supervision.option3.feature5': 'Уже включено — без дополнительных затрат для вас',
  'supervision.option3.pricing': 'Что вы получаете: Экспертный взгляд, всегда рядом',

  'supervision.why.title': 'Вы не должны просто надеяться на лучшее',
  'supervision.why.desc': 'Поехать за рубеж на стоматологическое лечение требует смелости. Вы доверяете людям, которых никогда не встречали, в стране, которую, возможно, не знаете, с чем-то таким личным, как ваша улыбка. Мы создали нашу систему наблюдения, потому что верим: вы заслуживаете большего, чем обещание — вы заслуживаете реального человека, который следит за каждым решением, принятым в отношении вашего лечения.',

  // CTA
  'cta.title.line1': 'Ваша улыбка ждала',
  'cta.title.line2': 'Уже достаточно долго',
  'cta.subtitle1': 'Мы знаем, что сделать этот шаг непросто. Неопределённость, вопросы, «а вдруг» — мы слышим их каждый день. Именно поэтому мы здесь.',
  'cta.subtitle2': 'Ваш первый разговор бесплатный, без давления и полностью на ваших условиях. Просто поговорите с нами — мы возьмём всё остальное на себя.',
  'cta.button.primary': 'Я готов поговорить',
  'cta.button.secondary': 'Написать в WhatsApp',
  'cta.badge1': 'Настоящие врачи. Настоящая забота.',
  'cta.badge2': 'Без давления. Без спешки.',
  'cta.badge3': 'Поддержка на каждом шагу.',
  'cta.badge4': 'Реальные результаты. Реальные люди.',

  // Footer
  'footer.brand.desc': 'Мы верим, что каждый заслуживает чувствовать уверенность в своей улыбке. Мы здесь, чтобы сделать это возможным — безопасно, честно и с настоящим врачом рядом.',
  'footer.cta': 'Записаться на консультацию',
  'footer.treatments': 'Лечение',
  'footer.company': 'Компания',
  'footer.resources': 'Ресурсы',
  'footer.phone': 'Телефон',
  'footer.email': 'Эл. почта',
  'footer.location': 'Местоположение',
  'footer.locationValue': 'Стамбул, Турция',
  'footer.copyright': '© {{year}} Plexus Alliance. Все права защищены.',
  'footer.poweredBy': 'Разработано Readdy',

  'about.hero.badge': 'Наша история',
  'about.hero.title': 'Мы создали защитную сеть, которой не хватало стоматологическому туризму',
  'about.hero.subtitle': 'Plexus Alliance основана на простой убеждённости: пациенты заслуживают независимого голоса в своём лечении — особенно вдали от дома.',
  'about.mission.badge': 'Наша миссия',
  'about.mission.title': 'Прозрачная, контролируемая стоматологическая помощь для каждого пациента, везде.',
  'about.mission.desc': 'Мы соединяем пациентов с лучшими стоматологическими клиниками Стамбула, обеспечивая независимый надзор, которого большинство компаний стоматологического туризма просто не предлагают.',
  'about.values.badge': 'Во что мы верим',
  'about.values.title': 'Наши основные ценности',
  'about.value1.title': 'Независимость',
  'about.value1.desc': 'Наши наблюдатели отвечают только перед вами — никогда перед клиникой.',
  'about.value2.title': 'Прозрачность',
  'about.value2.desc': 'Каждая запись, каждый скан, каждое решение — полностью видны вам.',
  'about.value3.title': 'Преемственность',
  'about.value3.desc': 'Ваше лечение не заканчивается, когда вы садитесь в самолёт домой.',
  'about.value4.title': 'Доступность',
  'about.value4.desc': 'Стоматологическая помощь мирового класса не должна быть привилегией. Мы делаем её доступной.',
  'treatments.hero.badge': 'Все процедуры',
  'treatments.hero.title': 'Найдите своё лечение',
  'treatments.hero.subtitle': 'От одного импланта до полного преображения улыбки — каждая процедура под наблюдением, прозрачна и справедливо оценена.',
  'treatments.filter.all': 'Все процедуры',
  'treatments.filter.implants': 'Импланты',
  'treatments.filter.cosmetic': 'Косметика',
  'treatments.filter.orthodontics': 'Ортодонтия',
  'treatments.filter.restorative': 'Реставрация',
  'treatments.cta.title': 'Не уверены, какое лечение вам нужно?',
  'treatments.cta.desc': 'Расскажите нам, что вас беспокоит — мы бесплатно изучим ваш случай и порекомендуем правильный путь.',
  'treatments.cta.button': 'Получить бесплатную оценку',
  'book.hero.badge': 'Начните свой путь',
  'book.hero.title': 'Запишитесь на лечение',
  'book.hero.subtitle': 'Заполните данные ниже, и мы свяжемся с вами в течение нескольких часов с персональным планом.',
  'book.form.name': 'Полное имя',
  'book.form.email': 'Адрес электронной почты',
  'book.form.phone': 'Телефон / WhatsApp',
  'book.form.treatment': 'Интересующая процедура',
  'book.form.supervision': 'Предпочтение по наблюдению',
  'book.form.message': 'Расскажите подробнее (необязательно)',
  'book.form.submit': 'Отправить заявку',
  'book.form.submitting': 'Отправка...',
  'book.form.success': 'Заявка отправлена! Мы свяжемся с вами в течение нескольких часов.',
  'partner.hero.badge': 'Стать партнёром',
  'partner.hero.title': 'Присоединитесь к сети Plexus Alliance',
  'partner.hero.subtitle': 'Вы стоматолог, клиника или медицинский специалист? Станьте партнёром и зарабатывайте, помогая пациентам получить помощь мирового класса.',
  'partner.form.submit': 'Подать заявку',
  'hiw.hero.badge': 'Процесс',
  'hiw.hero.title': 'Как это работает',
  'hiw.hero.subtitle': 'От первого сообщения до последнего осмотра — вот что происходит шаг за шагом.',
  'hiw.faq.title': 'Остались вопросы?',
  'hiw.cta.title': 'Готовы сделать первый шаг?',
  'hiw.cta.subtitle': 'Всё начинается с одного сообщения. Скажите нам, что вам нужно — мы возьмём всё остальное на себя.',
  'hiw.cta.button': 'Начать мой путь',
  'sup.hero.badge': 'Ваша защита',
  'sup.hero.title': 'Медицинское наблюдение',
  'sup.hero.subtitle': 'Единственное, чего не предлагает большинство компаний стоматологического туризма — и единственное, что имеет решающее значение.',
  'sup.why.title': 'Большинство клиник работают на себя. Мы работаем на вас.',
  'sup.options.title': 'Три способа оставаться под защитой',
  'sup.pillars.title': 'Что получает каждый пациент под наблюдением',
  'sup.compare.title': 'С наблюдением и без',
  'sup.faq.title': 'Вопросы о наблюдении',
  'sup.cta.title': 'Ваше здоровье заслуживает независимого голоса.',
  'sup.cta.button': 'Записаться с наблюдением',
  'common.learnMore': 'Узнать больше',
  'common.bookNow': 'Записаться',
  'common.startJourney': 'Начать мой путь',
  'common.getStarted': 'Начать',
  'common.contactUs': 'Связаться с нами',
  'common.readMore': 'Читать далее',
  'common.viewAll': 'Посмотреть всё',
  'common.close': 'Закрыть',
  'common.back': 'Назад',
  'common.next': 'Далее',
  'common.loading': 'Загрузка...',
  'common.error': 'Что-то пошло не так. Пожалуйста, попробуйте снова.',
  'common.required': 'Это поле обязательно',
  'common.optional': 'Необязательно',
  'common.saving': 'Экономия от',
  'common.perTooth': 'за зуб',
  'common.included': 'Включено',
  'common.mostTrusted': 'Наиболее надёжный',
  'common.mostComfortable': 'Наиболее комфортный',
  'common.yearsExperience': 'лет опыта',
  'common.patients': 'пациентов',
  'common.countries': 'стран',
  'common.savings': 'экономия',
};

export default common;
